"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Link = function Link(_ref) {
  var className = _ref.className,
      to = _ref.to,
      children = _ref.children,
      forwardRef = _ref.forwardRef,
      otherProps = _objectWithoutProperties(_ref, ["className", "to", "children", "forwardRef"]);

  var parseTo = function parseTo(to) {
    var parser = document.createElement('a');
    parser.href = to;
    return parser;
  };

  var isInternalCheck = function isInternalCheck(toLocation) {
    return window.location.host === toLocation.host;
  };

  var toLocation = parseTo(to);
  var isInternal = isInternalCheck(toLocation);

  if (isInternal) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({
      innerRef: forwardRef,
      className: className,
      to: toLocation.pathname
    }, otherProps), children);
  } else {
    return /*#__PURE__*/_react.default.createElement("a", _extends({
      ref: forwardRef,
      className: className,
      href: to,
      target: "_blank"
    }, otherProps), children);
  }
};

var _default = Link;
exports.default = _default;